import { EDealType, TWantType } from 'shared/types/features';

export const WANT_KNOW_TYPE: TWantType[] = [
  {
    id: EDealType.Sale,
    text: 'Продажу',
    imgClass: 'coin',
  },
  {
    id: EDealType.Rent,
    text: 'Аренду',
    imgClass: 'key',
  },
];
